import type { Enums } from "../types";

/**
 * Every state a return run can hold, in lifecycle order rather than the order the enum declares
 * them — which is what a filter reads left to right.
 *
 * Only one of the three moves is a decision anybody makes: the column default gives `open`, the
 * first booking gives `in-progress`, and closing the run is what offers `complete` and `canceled`.
 * The filter carries all four anyway, because it narrows what the list *shows* rather than what a
 * caller may write, and a settled run has to stay findable.
 *
 * `satisfies` rather than a plain annotation, so the tuple keeps its literal members for `z.enum`
 * while still failing to compile if the database enum gains a state this list does not.
 */
export const RETURN_ORDER_STATES = [
	"open",
	"in-progress",
	"complete",
	"canceled",
] as const satisfies ReadonlyArray<Enums<"returnOrderState">>;
